<template>
<div
	class="m-0 p-0"
	:class="{'px-1': isDesktop}"
>
	<!-- Service unit -->
	<drop-down-spoiler :show="true">
		<template v-slot:title>
			<div class="row row-cols-2 m-0 p-0">
				<div class="col-auto text-nowrap d-flex">
					<unit-icon unitType="service" />&nbsp;
					<h6 class="fs-5 fw-bold text-nowrap m-0">Сервісний модуль</h6>
				</div>
				<div class="col-auto m-0 p-0 ms-3 me-1">
					<h6
						class="font-monospace text-truncate m-0 p-0"
						:class="{
							'text-danger': rpcTaskSchema.state.isErorrState(serviceUnitRpcState),
							'text-success': !rpcTaskSchema.state.isErorrState(serviceUnitRpcState)
						}"
					>
						{{ taskStateDescription(serviceUnitRpcState) }}
					</h6>
				</div>
			</div>
		</template>
		<template v-slot:body>
			<service-unit-calibration
				v-if="isSettingsLoad"
				:class="{
					'px-2': isDesktop,
					'px-0': isMobile,
				}"
				:station-id="stationId"
				@rpc="(rpc) => serviceUnitRpcState = rpc?.state"
			/>
		</template>
	</drop-down-spoiler>
</div>
</template>


<script>
import DropDownSpoiler from '../DropDownSpoiler.vue'
import UnitIcon from '@/components/Icons/UnitIcon.vue'
import ServiceUnitCalibration from './ServiceUnitCalibration.vue'
import { useSizeBreakpoint } from '@/composables/size-breakpoint.js'
import { useAccontStore } from '@/stores/AccountStore.js'
import { useStationsStore } from '@/stores/StationsStore.js'
import { rpcTaskSchema } from '@/composables/rpcTasks.js'
import { Station } from '@/models/station'

export default {
	components: {
		DropDownSpoiler,
		UnitIcon,
		ServiceUnitCalibration,
	},

	props: {
		stationId: {
			type: String,
			require: true,
		},
	},

	setup() {
		const { isDesktop, isMobile } = useSizeBreakpoint()
		const accountStore = useAccontStore()
		const stationsStore = useStationsStore()

		return {
			isDesktop,
			isMobile,
			accountStore,
			stationsStore,
			Station,
			rpcTaskSchema,
		}
	},

	data() {
		return {
			isSettingsLoad: false,
			//
			serviceUnitRpcState: '',
		}
	},

	created() {
		// Read station passport
		this.stationsStore.readPassport(
			(result) => { this.isSettingsLoad = result },
			this.stationId
		)
	},

	mounted() {
	},

	methods: {
		taskStateDescription(state) {
			const stateObj = rpcTaskSchema.state.findState(state)
			return stateObj == undefined || stateObj == false
				? '-'
				: stateObj.title
		},
	},

	computed: {
		station() { return this.stationsStore.station(this.stationId) },
	},
}
</script>




<style scoped>
</style>
